"use client"

import {
  NavigateWithThread,
  EntityDetailSkeleton,
  MatchDetailShell,
  EvaluationAnalysisView,
  PageContainer,
  PageHeader,
  PageHeaderActions,
  PageHeaderLeading,
  ProfilePdfDownloadButton,
  isProfilePdfEnabled,
  Card,
  CardContent,
  PersonProfileReadView,
} from '@yeshuman/sdk'
import { SaveToBriefControl } from './save-to-brief-control'
import { ProfileInterviewOutcomesSection } from './profile-interview-outcomes-section'
import { useRecruiterPersonMatchState } from '../../hooks/use-recruiter-person-match-state'

export function RecruiterPersonMatchPage() {
  const state = useRecruiterPersonMatchState()

  if (state.missingRequired) {
    return <NavigateWithThread to="/recruiter/talent" />
  }

  if (state.isLoading) {
    return <EntityDetailSkeleton variant="job" ariaLabel="Loading candidate" />
  }

  if (state.missingData || !state.profile) {
    return (
      <PageContainer>
        <PageHeaderLeading back={{ label: 'Back', to: state.backPath }} />
          <PageHeader title="Candidate" description="This candidate could not be loaded." />
        </PageContainer>
    )
  }

  const profilePanel = (
    <Card>
      <CardContent className="pt-[var(--sp-card)]">
        <PersonProfileReadView
          profile={state.profile}
          footer={<ProfileInterviewOutcomesSection profileId={state.profileId} />}
        />
        <div className="mt-4 flex flex-wrap gap-2 border-t border-border/60 pt-4">
          <SaveToBriefControl
            profileId={state.profileId}
            profileName={state.displayName}
            stopPropagation={false}
          />
        </div>
      </CardContent>
    </Card>
  )

  const pdfActions =
    isProfilePdfEnabled() && state.profileId ? (
      <PageHeaderActions secondary={<ProfilePdfDownloadButton profileId={state.profileId} />} />
    ) : undefined

  return (
    <MatchDetailShell
      mode="person"
      title={state.displayName}
      description="Analysis match"
      breadcrumbs={state.breadcrumbs}
      actions={pdfActions}
      activeTab={state.activeTab}
      onTabChange={state.setActiveTab}
      hasAnalysis={state.hasAnalysis}
      analysisPanel={
        state.evaluationId ? (
          <EvaluationAnalysisView
            evaluationId={state.evaluationId}
            subjectLabel={state.displayName}
          />
        ) : null
      }
      secondaryPanel={profilePanel}
    />
  )
}
